import React from 'react';
import { Alert } from '@mui/material';
import { useLocation } from 'react-router-dom';

// Must equal the links of the "Development / Lab" nav group in Layout.jsx (DevAreaBanner.test.js enforces it).
export const DEV_AREA_ROUTES = [
  '/exec',
  '/impact',
  '/platform-usage',
  '/events/xperts24',
  '/events/xperts25',
];

export default function DevAreaBanner() {
  const { pathname } = useLocation();
  if (!DEV_AREA_ROUTES.includes(pathname.replace(/(.)\/$/, '$1'))) return null;
  return (
    <Alert severity="warning" aria-label="in-development banner" sx={{ mx: { xs: 1, sm: 2 }, mt: 1 }}>
      In development and not reliable: numbers on this page are not validated and may use older definitions.
    </Alert>
  );
}
